import "../../../../assets/styles/Common.css";
import { useState, useRef } from "react";
import { useEffect } from "react";
import Tooltip from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Eduvatelogo from "../../../../assets/images/Eduvatelogo.svg";
import InviteAFriendModal from "../../modals/InviteAFriendModal";
import ShareYourFeedbackModal from "../../modals/ShareYourFeedbackModal";
import useCanvasDetection from "../../../hooks/useCanvasDetection";
import GoPremiumModal from "../../modals/GoPremiumModal";
import GoForUnlimitedQuestionsModal from "../../modals/GoForUnlimitedQuestionsModal";
import { fetchUsersAllQuestions } from "../../../api/fetchUsersAllQuestions";
import LoadingOverlay from "../../overlays/LoadingOverlay";
import { logout } from "../../../api/logout";
import QuillionzProUpgradeModal from "../../../components/modals/QuillionzProUpgradeModal";

const AppNavigation = (props) => {
  const navigate = useNavigate();
  // State variable to control the visibility of the menu on small devices
  const [showMenu, setShowMenu] = useState(false);

  const [logoutDialog, setLogoutDialog] = useState(false);

  const [showInviteModal, setShowInviteModal] = useState(false);

  const [showFeedbackModal, setShowFeedbackModal] = useState(false);

  const [showGoPremiumModal, setShowGoPremiumModal] = useState(false);

  const attemptsFromDatabase = localStorage.getItem("UserAttempts");

  const [remainingAttempt, setRemainingAttempt] =
    useState(attemptsFromDatabase);

  const [showUnlimitedModal, setShowUnlimitedModal] = useState(false);

  const Version = localStorage.getItem('Version');
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false);

  const [showManageSubscription, setShowManageSubscription] = useState(false);

  // Function to handle opening the "Invite a Friend" modal
  const handleInviteFriendClick = () => {
    setShowInviteModal(true);
  };

  const location = useLocation();

  // Function to navigate to 'submitContent'
  const handleNewContent = () => {
    localStorage.removeItem("title");
    localStorage.removeItem("content");
    localStorage.removeItem("doc_id");
    localStorage.removeItem("domain");
    localStorage.removeItem("keywordsResponse");
    localStorage.removeItem("contentReadiness");
    localStorage.removeItem("reviewContentResponse");
    localStorage.removeItem("selectedKeywordsArray");
    localStorage.removeItem("totalQuestionsGenerated");
    localStorage.removeItem("whQuestionsCount");
    localStorage.removeItem("isSampleButtonClicked");
    localStorage.removeItem("QAreqbody");
    if (location.pathname === "/submitcontent") {
      // sessionStorage.setItem("canvas", "true");
      if (!isCanvas) {
        // window.location.reload();
        window.location.href = "/submitcontent";
      } else {
        props.setContent('');
        props.setTitle('');
        props.setDomain('');
        props.setSelectedFile(null);
        navigate("/submitcontent");
      }
    } else {
      navigate("/submitcontent");
    }
  };

  // Function to handle opening the "Share Your Feedback" modal
  const handleFeebackClick = () => {
    setShowFeedbackModal(true);
  };

  // Function to handle opening the "Go Premium" modal
  const handleGoPremiumClick = () => {
    setShowGoPremiumModal(true);
  };

  // Function to handle closing the modal
  const handleModalClose = () => {
    setLogoutDialog(false); // Close the modal
    // Do any other logic you need before redirecting to "/"
  };

  // Getting username and userGPTKey
  const username = localStorage.getItem("username");
  const userGPTKey = localStorage.getItem("userGPTKey");
  const Email = localStorage.getItem("email");
  // Function to handle clicks outside the dropdown container
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    // Event listener added for clicks outside the dropdown container
    document.addEventListener("click", handleOutsideClick);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  // Function to toggle the visibility of the menu on small devices
  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  // Function to toggle the visibility of the dropdown when clicking on "Username"
  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  // Function to handle the click of each option in the dropdown menu
  const ContactforAPI = () => {
    window.location.href = 'mailto:support@quillionz.com';
  };

  // Function to handle the logout
  const handleLogout = async () => {
    try {
      setIsLoading(true);
      await logout(localStorage.getItem("email"));
      localStorage.clear();
      sessionStorage.removeItem("isLoggedIn");
      setIsLoading(false);
      navigate("/");
      setLogoutDialog(true);
    } catch (error) {
      console.log("Error while logout : ", error);
      setLogoutDialog(true);
    }
  };

  // Function to navigate to userinfo page
  const handleAccountInfo = () => {
    navigate("/userinfo");
  };

  // If remaining attempts reach zero, open the UnlimitedModal
  const handleRemainingAttempts = () => {
    setShowUnlimitedModal(true);
  };

  const handleAttemptClick = () => {
    if (remainingAttempt > 0) {
      setRemainingAttempt((prevAttempt) => prevAttempt - 1);
    }
  };

  // Function to navigate to history page which has users all questions sets.
  const handleUsersQuestionsHistory = async () => {
    if (!isCanvas) {
      navigate("/history");
    } else {
      setIsLoading(true);
      const userQuestionsHistory = await fetchUsersAllQuestions(localStorage.getItem("email"));
      localStorage.setItem(
        "usersQuestionHistory",
        JSON.stringify(userQuestionsHistory.data.doc_list)
      );
      navigate("/history");
      setIsLoading(false);
    }
  };
  const isCanvas = useCanvasDetection();

  // Background color to Attempts Circle icon
  const circleIconStyle = (remainingAttempt) => {
    const percentage = ((25 - remainingAttempt) / 25) * 100;

    return {
      background:
        remainingAttempt <= 2
          ? `linear-gradient(to top, red ${percentage}%, transparent ${percentage}%, transparent 100%)`
          : // : `linear-gradient(to top, #042739 ${percentage}%, transparent ${percentage}%, transparent 100%)`,
            "",
      backgroundSize: "200% 200%", // Added for wave animation
      animation: "wave 0.1s linear infinite", // Added for wave animation
      border: remainingAttempt <= 2 ? "2px solid red" : "2px solid #000000",
    };
  };

  const isPlanExpired = localStorage.getItem("isPlanExpired");

  // #0c5882
  return (
    <div>
      <div className="">
        {/* Navigatin bar starts here */}

        <nav className="bg-[#042739] h-[12vh] p-[10px] flex justify-between items-center md:flex sm:grid">
          <div className="flex items-center w-[20vh] pl-[2.5rem]">
            {/* Eduvate Logo */}
            <Link to={"/submitcontent"}>
              <img src={Eduvatelogo} alt="Logo"/>
            </Link>
          </div>

          {/* Hamburger menu button (visible only on small devices) */}
          <div className="md:hidden">
            <button onClick={toggleMenu}>
              <svg
                className="w-6 h-6 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                />
              </svg>
            </button>
          </div>

          {/* Menu items (visible on larger devices) */}
          <div
            className={`md:flex items-center ${showMenu ? "block" : "hidden"}`}
          >
            <ul className="md:flex space-x-4 ">
              {/* Invite a Friend */}
              {/* {isCanvas === true ? (
                ""
              ) : (
                <li className="nav-item ">
                  <button
                    className="nav-button "
                    onClick={handleInviteFriendClick}
                  >
                    <i className="fa-solid fa-user-group "></i> Invite a Friend
                  </button>
                </li>
              )} */}

              {/* New Content */}
              <li className="nav-item">
                <button className="nav-button" onClick={handleNewContent}>
                  <i className="fa-solid fa-file-circle-plus"></i> New Content
                </button>
              </li>

              {/* History */}
              <li className="nav-item">
                <button
                  className="nav-button"
                  onClick={() => {
                    handleUsersQuestionsHistory();
                  }}
                >
                  <i className="fa-solid fa-clock-rotate-left"></i> History
                </button>
              </li>

              {/* Remaining Question Sets */}
              {userGPTKey === "LIMITED" ? (
                <li className="nav-item bg-[#0c5882] rounded-lg hover:opacity-90 ">
                  {remainingAttempt > 0 && isPlanExpired == "false" ? (
                    <Tooltip
                      title={`Quiz Sets Left : ${remainingAttempt} of 5`}
                      arrow
                      placement="top"
                      TransitionComponent={Zoom}
                      TransitionProps={{ timeout: 300 }}
                    >
                      <button
                        className=""
                        id="go_premium_button"
                        onClick={handleRemainingAttempts}
                      >
                        <div className="flex flex-row items-center">
                          <div>Quiz Sets Left</div>
                          <div
                            className="circle-icon ml-2 bg-[#000000]"
                            style={circleIconStyle(remainingAttempt)}
                          >
                           <span className={`${remainingAttempt <= 2 ? "count text-white" : "count text-orange-500"}`}>{remainingAttempt}</span>
                          </div>
                        </div>
                      </button>
                    </Tooltip>
                  ) : isPlanExpired === "true" ? 
                    <Tooltip
                      title={
                        <span>
                          <i
                            className="pe-2 fa-solid fa-triangle-exclamation"
                            style={{ color: "white" }}
                          ></i>
                          Want to create more? Upgrade your plan!
                        </span>
                      }
                      arrow
                      placement="top"
                      TransitionComponent={Zoom}
                      TransitionProps={{ timeout: 300 }}
                    >
                      <button
                        className=""
                        id="go_premium_button"
                        // onClick={() => setShowManageSubscription(true)}
                         onClick={() => Version === 'Free' ? setShowManageSubscription(true) : setShowUnlimitedModal(true)}
                      >
                        Upgrade to Plan
                      </button>
                    </Tooltip>
                   : Version === 'Free' ? 
                    <>
                    <Tooltip
                      title={
                        <span>
                          <i
                            className="pe-2 fa-solid fa-triangle-exclamation"
                            style={{ color: "white" }}
                          ></i>
                          Purchase your plan!
                        </span>
                      }
                      arrow
                      placement="top"
                      TransitionComponent={Zoom}
                      TransitionProps={{ timeout: 300 }}
                    >
                      <button
                        className=""
                        id="go_premium_button"
                        // onClick={() => setShowManageSubscription(true)}
                         onClick={() => Version === 'Free' ? setShowManageSubscription(true) : setShowUnlimitedModal(true)}
                      >
                        Purchase Plan
                      </button>
                    </Tooltip>
                  </>
                  :
                    <>
                    <Tooltip
                      title={
                        <span>
                          <i
                            className="pe-2 fa-solid fa-triangle-exclamation"
                            style={{ color: "white" }}
                          ></i>
                          Want to create more? Upgrade your plan!
                        </span>
                      }
                      arrow
                      placement="top"
                      TransitionComponent={Zoom}
                      TransitionProps={{ timeout: 300 }}
                    >
                      <button
                        className=""
                        id="go_premium_button"
                        // onClick={() => setShowManageSubscription(true)}
                         onClick={() => Version === 'Free' ? setShowManageSubscription(true) : setShowUnlimitedModal(true)}
                      >
                        Upgrade to Plan
                      </button>
                    </Tooltip>
                    </>
                  }
                </li>
              ) :
                    <Tooltip
                      title={
                        <span>
                          <i
                            className="pe-2 fa-solid fa-triangle-exclamation"
                            style={{ color: "white" }}
                          ></i>
                          Want to create more? Upgrade your plan!
                        </span>
                      }
                      arrow
                      placement="top"
                      TransitionComponent={Zoom}
                      TransitionProps={{ timeout: 300 }}
                    >
                      <button
                        className=""
                        id="go_premium_button"
                        // onClick={() => setShowManageSubscription(true)}
                        onClick={() => Version === 'Free' ? setShowManageSubscription(true) : setShowUnlimitedModal(true)}
                      >
                        Upgrade to Plan
                      </button>
                    </Tooltip>
                  }

              {/* Dropdown menu for "Username" starts here */}
              {isCanvas ? (
                ""
              ) : (
                <li className="nav-item relative text-start">
                  <div className="relative" ref={dropdownRef}>
                    <button className="nav-button" onClick={toggleDropdown}>
                      <i className="me-1 fa-solid fa-user text-white"></i>
                      <span className="text-white">{username || Email }</span> <i className="fa-solid fa-caret-down text-white"></i>
                      {/* Dropdown will appear when you click on "Username" */}
                      {showDropdown && (
                        <div className="absolute dropdown top-[2rem] right-0 w-[100px] bg-white text-black rounded-md shadow-lg ]">
                          <ul className="py-2">
                            {/* Account Info */}
                            <li
                              className="px-4 py-2 hover:text-[#0c5882]  hover:bg-gray-100 hover:rounded-3xl cursor-pointer"
                              onClick={handleAccountInfo}
                            >
                              Account Info
                            </li>

                            {/* Logout */}
                            <li
                              className="px-4 py-2 hover:text-[#0c5882] hover:bg-gray-100 hover:rounded-3xl cursor-pointer"
                              onClick={handleLogout}
                            >
                              Logout
                            </li>
                          </ul>
                        </div>
                      )}
                      {/* Dropdown menu for "Username" ends here */}
                    </button>
                  </div>
                </li>
              )}
            </ul>
          </div>
        </nav>

        {/* Navigation bar ends here */}

        {/* Render the Invite A Friend Modal component */}
        {isCanvas === true ? (
          ""
        ) : (
          <InviteAFriendModal
            open={showInviteModal}
            onClose={() => setShowInviteModal(false)}
          />
        )}

        {/* Render the Share Your Feedback Modal component */}
        {isCanvas ? (
          ""
        ) : (
          <ShareYourFeedbackModal
            open={showFeedbackModal}
            onClose={() => setShowFeedbackModal(false)}
          />
        )}

        {/* Render the Go Premium Modal component */}
        {/* "Go For Unlimited" is currently on hold. We will resume work on it later */}
        <GoPremiumModal
          open={showGoPremiumModal}
          onClose={() => setShowGoPremiumModal(false)}
        />

        <GoForUnlimitedQuestionsModal
          open={showUnlimitedModal}
          onClose={() => setShowUnlimitedModal(false)}
        />

{/* Render the Go Premium Modal component */}
        <QuillionzProUpgradeModal
          isOpen={showManageSubscription}
          onClose={() => setShowManageSubscription(false)}
        />
        {/* Loading overlay */}
        {isLoading && <LoadingOverlay />}
      </div>
    </div>
  );
};

export default AppNavigation;
